import React, { useEffect, useState } from "react";
import logo from "../assets/logo.png";

/*
  AUTH PAGE – LOGIN + REFERANSLI KAYIT
  ✔ Kayıtlı kullanıcı: Login
  ✔ Kayıtsız kullanıcı: Referanslı Register
  ✔ Token → localStorage
*/

const API = "https://api.haymestasarim.com/api";



export default function AuthPage({ onAuth }) {
const [showPassword, setShowPassword] = useState(false);
const [showPassword2, setShowPassword2] = useState(false);

// 🔹 ŞİFREMİ UNUTTUM (EKLENDİ)
const [forgotOpen, setForgotOpen] = useState(false);
const [forgotEmail, setForgotEmail] = useState("");

// 🔹 MEVCUT KODLAR
const [mode, setMode] = useState("login");
const [loading, setLoading] = useState(false);
const [message, setMessage] = useState(null);


  /* LOGIN */
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  /* REGISTER */
  const [company, setCompany] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
const [kvkkAccepted, setKvkkAccepted] = useState(false);
const [kvkkOpen, setKvkkOpen] = useState(false);


const [country, setCountry] = useState("");

const [cities, setCities] = useState([]);
const [districts, setDistricts] = useState([]);

const [city, setCity] = useState("");        // city_id
const [district, setDistrict] = useState(""); // district_id


  const [refCode, setRefCode] = useState("");
  const [refLocked, setRefLocked] = useState(false);

useEffect(() => {
  if (kvkkOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }

  return () => {
    document.body.style.overflow = "auto";
  };
}, [kvkkOpen]);



useEffect(() => {
  setCity("");
  setDistrict("");
  setCities([]);
  setDistricts([]);

  if (country !== "Türkiye") return;
fetch(`${API}/auth/locations/tr/cities`)
  .then(r => r.json())
  .then(d => setCities(d || []))
    .catch(err => console.error("CITIES ERROR", err));
}, [country]);



useEffect(() => {
  setDistrict("");

  if (!city) {
    setDistricts([]);
    return;
  }

fetch(`${API}/auth/locations/tr/districts?city_id=${city}`)
  .then(r => r.json())
  .then(d => setDistricts(d || []))
    .catch(err => console.error("DISTRICTS ERROR", err));
}, [city]);



/* REF FROM URL (HashRouter Uyumlu) */
useEffect(() => {
  const hash = window.location.hash;
  // Örnek: "#/dashboard?ref=TESTREF"

  if (!hash.includes("?")) return;

  const queryString = hash.split("?")[1];
  const params = new URLSearchParams(queryString);
  const ref = params.get("ref");

  if (ref) {
    setRefCode(ref);
    setRefLocked(true);
    setMode("register");
  }
}, []);


/* AUTO REF PREVIEW (SADECE İLÇE + İL LİDERİ GÖSTERİR) */
useEffect(() => {
  // URL'den ref geldiyse dokunma
  if (refLocked) return;

  // Ülke yoksa olmaz
  if (!country) return;

  // 🇹🇷 Türkiye için: İL + İLÇE ZORUNLU
  if (country === "Türkiye" && (!city || !district)) {
    setRefCode(""); // 👈 BOŞ KALSIN
    return;
  }

  fetch(`${API}/auth/auto-ref-preview`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      country,
      city,
      district,
    }),
  })
    .then(r => r.json())
    .then(d => {
      // SADECE gerçek il / ilçe lideri varsa göster
      if (d?.ref_code) {
        setRefCode(d.ref_code);
      } else {
        setRefCode("");
      }
    })
    .catch(() => {
      setRefCode("");
    });
}, [country, city, district, refLocked]);



  /* MOBILE FIX */
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @media (max-width: 768px) {
        .auth-card {
          grid-template-columns: 1fr !important;
        }
        .auth-image {
          display: none !important;
        }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  /* ================= LOGIN ================= */
  const login = async () => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await fetch(`${API}/auth/giris`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: loginEmail,
          password: loginPassword,
        }),
      });

      const data = await res.json();

      if (res.ok && data?.token) {
        localStorage.setItem("user_token", data.token);
        onAuth?.();
      } else {
        setMessage({ type: "error", text: "Giriş başarısız" });
      }
    } catch {
      setMessage({ type: "error", text: "Sunucuya ulaşılamadı" });
    } finally {
      setLoading(false);
    }
  };

  /* ================= REGISTER ================= */
 const register = async () => {
  setMessage(null);

  // EMAIL regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // Şifre: min 8 karakter + harf + rakam
  const passRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

  // Zorunlu alanlar
  if (
    !company ||
    !name ||
    !email ||
    !password ||
    !password2 ||
    (country === "Türkiye" && (!city || !district))
  ) {
    setMessage({ type: "error", text: "Tüm alanlar zorunludur" });
    return;
  }
if (!kvkkAccepted) {
  setMessage({
    type: "error",
    text: "KVKK sözleşmesini kabul etmelisiniz",
  });
  return;
}



  // Email kontrol
  if (!emailRegex.test(email)) {
    setMessage({ type: "error", text: "Geçerli e-posta girin" });
    return;
  }

  // Şifre güçlü mü
  if (!passRegex.test(password)) {
    setMessage({
      type: "error",
      text: "Şifre en az 8 karakter, harf ve rakam içermeli",
    });
    return;
  }

  // Şifre eşleşme
  if (password !== password2) {
    setMessage({ type: "error", text: "Şifreler uyuşmuyor" });
    return;
  }

  setLoading(true);

  try {
    const res = await fetch(`${API}/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        company,
        ad: name,
        email: email.toLowerCase().trim(),
        sifre: password,
        country,
        city,
        district,
        ref_code: refCode || null,
  kvkk_accepted: kvkkAccepted,  // 🔥 EKLE

      }),
    });

    const data = await res.json();

    if (res.ok && data?.token) {
      localStorage.setItem("user_token", data.token);
      onAuth?.();
    } else {
      setMessage({
        type: "error",
        text: data?.message || "Kayıt başarısız",
      });
    }
  } catch {
    setMessage({ type: "error", text: "Sunucu hatası" });
  } finally {
    setLoading(false);
  }
};


  /* ================= UI ================= */
  return (
    <div style={styles.page}>
      <div style={styles.card} className="auth-card">
        <div style={styles.form}>
          <h2>{mode === "login" ? "Tekrar hoş geldiniz" : "Hesap oluştur"}</h2>
          <p style={styles.subtitle}>MesYat Dijital Çözümler</p>

          {message && (
            <div
              style={{
                ...styles.message,
                background: message.type === "error" ? "#fee2e2" : "#dcfce7",
              }}
            >
              {message.text}
            </div>
          )}

          {mode === "register" && (
            <>
           <input style={styles.input} placeholder="Kullanıcı Adı (Username) *" value={company} onChange={(e)=>setCompany(e.target.value)} />

              <input style={styles.input} placeholder="Ad Soyad *" value={name} onChange={(e)=>setName(e.target.value)} />
              <input style={styles.input} placeholder="E-posta *" value={email} onChange={(e)=>setEmail(e.target.value)} />
             <div style={{ position: "relative" }}>
  <input
    type={showPassword ? "text" : "password"}
    style={styles.input}
    placeholder="Şifre *"
    value={password}
    onChange={(e)=>setPassword(e.target.value)}
  />
  <span
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: 14,
      top: 14,
      cursor: "pointer",
      fontSize: 14,
      color: "#64748b",
    }}
  >
    {showPassword ? "🙈" : "👁️"}
  </span>
</div>

<div style={{ position: "relative" }}>
  <input
    type={showPassword2 ? "text" : "password"}
    style={styles.input}
    placeholder="Şifre Tekrar *"
    value={password2}
    onChange={(e)=>setPassword2(e.target.value)}
  />
  <span
    onClick={() => setShowPassword2(!showPassword2)}
    style={{
      position: "absolute",
      right: 14,
      top: 14,
      cursor: "pointer",
      fontSize: 14,
      color: "#64748b",
    }}
  >
    {showPassword2 ? "🙈" : "👁️"}
  </span>
</div>


<select
  style={styles.input}
  value={country}
  onChange={(e)=>setCountry(e.target.value)}
>
  <option value="">Ülke Seçiniz *</option>
  <option value="Türkiye">Türkiye</option>
  <option value="Almanya">Almanya</option>
  <option value="İsviçre">İsviçre</option>
</select>



{country === "Türkiye" && (
  <>
    <select
      style={styles.input}
      value={city}
      disabled={!cities.length}
      onChange={(e)=>setCity(e.target.value)}
    >
      <option value="">İl Seçiniz *</option>
      {cities.map(c => (
        <option key={c.id} value={c.id}>
          {c.name}
        </option>
      ))}
    </select>

    <select
      style={styles.input}
      value={district}
      disabled={!districts.length}
      onChange={(e)=>setDistrict(e.target.value)}
    >
      <option value="">İlçe Seçiniz *</option>
      {districts.map(d => (
        <option key={d.id} value={d.id}>
          {d.name}
        </option>
      ))}
    </select>
  </>
)}



<input
  style={{
    ...styles.input,
    background: "#f1f5f9",
    cursor: "not-allowed",
  }}
  placeholder="Referans Kodu"
  value={refCode}
  disabled
/>


<div style={{ display: "flex", alignItems: "flex-start", marginTop: 14 }}>
  <input
    type="checkbox"
    checked={kvkkAccepted}
    onChange={(e) => setKvkkAccepted(e.target.checked)}
    style={{ marginRight: 8, marginTop: 4 }}
  />

 <span style={{ fontSize: 13, lineHeight: 1.5 }}>
  <span
    onClick={() => setKvkkOpen(true)}
    style={{
      color: "#2563eb",
      textDecoration: "underline",
      cursor: "pointer"
    }}
  >
    KVKK Aydınlatma Metni
  </span>{" "}
  ’ni okudum ve kabul ediyorum.
</span>

</div>

</>
)}


          {mode === "login" && (
            <>
              <input style={styles.input} placeholder="E-posta" value={loginEmail} onChange={(e)=>setLoginEmail(e.target.value)} />
              <input type="password" style={styles.input} placeholder="Şifre" value={loginPassword} onChange={(e)=>setLoginPassword(e.target.value)} />
            </>
          )}

{mode === "login" && (
  <div
    onClick={() => setForgotOpen(true)}
    style={{
      textAlign: "right",
      marginTop: -6,
      marginBottom: 10,
      cursor: "pointer",
      fontWeight: 600,
      background: "linear-gradient(90deg,#2563eb,#f97316)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    }}
  >
    Şifremi Unuttum?
  </div>
)}



          <button
            style={styles.primaryBtn}
            onClick={mode === "login" ? login : register}
          >
            {loading ? "Bekleyin..." : mode === "login" ? "Giriş" : "Kaydol"}
          </button>

          {!refLocked && (
  <div style={styles.switch}>
    {mode === "login" ? (
      <>Hesabın yok mu? <span onClick={()=>setMode("register")}>Kaydol</span></>
    ) : (
      <>Zaten hesabın var mı? <span onClick={()=>setMode("login")}>Oturum Aç</span></>
    )}
  </div>
)}
        </div>

        <div style={styles.image} className="auth-image">
          <img src={logo} alt="MesYat Dijital" style={{ width:200, maxWidth:"80%" }} />
        </div>


{forgotOpen && (
  <div style={styles.forgotOverlay}>
    <div style={styles.forgotCard}>
      <h3>Şifremi Unuttum</h3>
      <p style={{ color: "#64748b", fontSize: 14 }}>
        E-posta adresini gir, sana şifre yenileme linki gönderelim.
      </p>

      <input
        style={styles.input}
        placeholder="E-posta adresin"
        value={forgotEmail}
        onChange={(e) => setForgotEmail(e.target.value)}
      />

      <button
        style={{
          ...styles.primaryBtn,
          background: "#2563eb",
        }}
        onClick={async () => {
          try {
await fetch(`${API}/network-passport/forgot-password`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ email: forgotEmail }),
            });
            alert("E-posta gönderildi. Gelen kutunu kontrol et.");
            setForgotOpen(false);
            setForgotEmail("");
          } catch {
            alert("Bir hata oluştu");
          }
        }}
      >
        Link Gönder
      </button>

      <button
        onClick={() => setForgotOpen(false)}
        style={{
          marginTop: 10,
          background: "transparent",
          border: "none",
          color: "#f97316",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Vazgeç
      </button>
    </div>
  </div>
)}


{/* ✅ BURAYA EKLE */}

{kvkkOpen && (
  <div style={styles.kvkkOverlay}>
    <div style={styles.kvkkCard}>
      <h3>Kişisel Verilerin Korunması Aydınlatma Metni</h3>

      <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6 }}>
        MesYat Dijital Çözümler olarak 6698 sayılı KVKK kapsamında
        kişisel verilerinizin güvenliğine önem veriyoruz.
        Ad, soyad, e-posta ve konum bilgileriniz yalnızca
        hizmet sunumu amacıyla işlenir ve üçüncü kişilerle paylaşılmaz.
      </p>

      <p style={{ fontSize: 14, color: "#64748b", lineHeight: 1.6 }}>
        KVKK'nın 11. maddesi kapsamında verilerinizle ilgili
        bilgi talep etme, düzeltme ve silme hakkına sahipsiniz.
      </p>

     <button
  style={{
    ...styles.primaryBtn,
    marginTop: 20,
  }}
  onClick={() => {
    setKvkkAccepted(true);
    setKvkkOpen(false);
  }}
>
  Okudum ve Kabul Ediyorum
</button>

    </div>
  </div>
)}


      </div>
    </div>
  );
}

/* ================= STYLES ================= */
const styles = {
  page:{minHeight:"100vh",background:"#f8fafc",display:"flex",justifyContent:"center",alignItems:"center"},
  card:{width:920,background:"#fff",borderRadius:16,display:"grid",gridTemplateColumns:"1fr 1fr",boxShadow:"0 20px 40px rgba(0,0,0,.12)",overflow:"hidden"},
  form:{padding:40},
  subtitle:{color:"#64748b",marginBottom:20},
  input:{width:"100%",padding:14,borderRadius:10,border:"1px solid #d1d5db",marginBottom:12},
  primaryBtn:{width:"100%",padding:14,borderRadius:10,background:"#2563eb",color:"#fff",fontWeight:700,border:"none",marginTop:10},
  switch:{marginTop:16,textAlign:"center",cursor:"pointer",color:"#f97316",fontWeight:600},
  message:{padding:12,borderRadius:8,marginBottom:12,fontWeight:600},
  image:{background:"linear-gradient(135deg,#2563eb,#f97316)",display:"flex",justifyContent:"center",alignItems:"center"},


forgotOverlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.45)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 999,
},
forgotCard: {
  width: 360,
  background: "#fff",
  padding: 24,
  borderRadius: 14,
  boxShadow: "0 20px 40px rgba(0,0,0,.25)",
  textAlign: "center",
},
kvkkOverlay: {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,.5)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
},

kvkkCard: {
  width: 600,
  maxWidth: "95%",
  maxHeight: "80vh",
  overflowY: "auto",
  background: "#fff",
  padding: 30,
  borderRadius: 18,
  boxShadow: "0 30px 60px rgba(0,0,0,.25)",
},



};


